(function() {
    'use strict';

    angular
        .module('szallodak-home-screen', ['ui.sortable']);
})();
